function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}


docReady(doIt);
function doIt() {
  // window.onWizzyScriptLoaded = function () {



    if(document.documentElement.clientWidth < 768) {
        let isAutocompleteMutationConfigured = false;
    
        const setMutationToAutocomplete = (id, options = {}) => {
          if (isAutocompleteMutationConfigured) return;
        
          let mutationHandler = (target) => {
            // console.log(target)
            let targetEle = target;
            let isVisible;
    
            if(targetEle.hasChildNodes()) {
              var x = targetEle.querySelector(".wizzy-autocomplete-wrapper");
              if(x != null) {
                isVisible = window.getComputedStyle(targetEle.querySelector(".wizzy-autocomplete-wrapper")).display === "flex";
              }else {
                return;
              }
            }else {
              if(targetEle.classList.contains("wizzy-autocomplete-wrapper")) {
                isVisible = window.getComputedStyle(targetEle).display == "flex";
              }else {
                return;
              }
            }
        
            if (isVisible) {
              var x = document.querySelector('.wizzy-autocomplete-wrapper');
              var currentTop = parseInt(x.style.top) || 0;
              var newTop = currentTop + 15;
              x.style.top = newTop + 'px';
              document.body.classList.add("wizzy-autocomplete-is-visible");
              document.body.classList.remove("wizzy-autocomplete-is-not-visible");
            } else {
              document.body.classList.remove("wizzy-autocomplete-is-visible");
              document.body.classList.add("wizzy-autocomplete-is-not-visible");
            }
          };
        
          let mutationStaticObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutationRecord) {
              switch (mutationRecord.type) {
                case "childList":
                  mutationHandler(mutationRecord.target);
                  break;
                case "subtree":
                  break;
                default:
                  // mutationHandler(mutationRecord.target);
              }
            });
          });
        
          mutationStaticObserver.observe(document.getElementById(id), options);
          isAutocompleteMutationConfigured = true;
        };
        
        let autocompleteId = ".wizzy-body-end-wrapper";
        document.querySelector(autocompleteId).setAttribute("id", "wizzy-body-end-wrapper");
        setMutationToAutocomplete("wizzy-body-end-wrapper", {
          subtree: true,
          childList: true,
          attributes: true,
        });
    
    
        document.querySelector("header").addEventListener("click", function (e) {
          var x = document.querySelector("body");
          if (x.classList.contains("wizzy-autocomplete-is-visible")) {
            x.classList.remove("wizzy-autocomplete-is-visible");
            x.classList.add("wizzy-autocomplete-is-not-visible");
          }
        }); 
    }
  





    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutationRecord) {
            if(mutationRecord.target.getAttribute('aria-hidden') == 'false') {
              setTimeout(function() {
                document.getElementById('wizzy-search').focus();
              }, 200);
            }else if(mutationRecord.target.getAttribute('aria-hidden') == 'true') {
              
            }
        });    
    });
    
    var target = document.getElementById('Search');
    observer.observe(target, { attributes : true, attributeFilter : ['aria-hidden'] });
  



  
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {

        data["search"]["configs"]["pagination"][
          "infiniteScrollOffset"
        ] = { desktop: 5000, mobile: 2000 };
        
        data.common.lazyDOMConfig.contentDOMIdentifiers.push('main');
        data.common.lazyDOMConfig.searchInputIdentifiers[0].dom = "#section-header input";
        data.common.lazyDOMConfig.searchInputIdentifiers[0].type = "search";
        data.common.lazyDOMConfig.identifiersToClickOnSearch[0] = '.Search__Close';
        return data;
    });

    
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(data) {
      let n = data.length;

      for(let i = 0; i < n; i++) {
        let m = data[i].attributes.length;
        for(let j = 0; j < m; j++) {
          if(data[i].attributes[j].id === "product_value_tags_bestseller") {
            data[i].isBestSeller = true;
          }else if(data[i].attributes[j].id === "product_value_tags_new_arrivals") {
            data[i].isNewArrival = true;
          }
        }
      }
      return data;
    });


    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(data) {
      if(document.documentElement.clientWidth < 768) {
        var x = document.querySelector("body");
        if (x.classList.contains("wizzy-autocomplete-is-visible")) {
          x.classList.remove("wizzy-autocomplete-is-visible");
          x.classList.add("wizzy-autocomplete-is-not-visible");
        }
      }
      return data;
    });


  
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function(data) {
      var facets = data.response.payload.facets;
      facets.forEach((facet) => {
          if (facet.key === "colors") {
              const facetItem = facet.data;
              facetItem.forEach((item) => {
                  item.isSwatch = true;
                  item.isVisualSwatch = true;
                  item.swatchValue = false;
                  item.data = {
                      value: item.key,
                      swatch: {
                          type: 'visual',
                          value: false
                      }
                  }
              })
          }
      })
      return data;
    })


  
  
  
    changeTemplate('wizzy-search-results-product');
    changeTemplate('wizzy-search-results');
  // }
}


const changeTemplate = (div) => {
  let oldDiv = document.getElementById(div);
  let newDiv = document.getElementById(div + '-new').text;
  oldDiv.text = newDiv;
}